import { render } from "./DiskOfferingForm.vue?vue&type=template&id=1e7f59c8"
import script from "./DiskOfferingForm.vue?vue&type=script&lang=js"
export * from "./DiskOfferingForm.vue?vue&type=script&lang=js"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__